import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaPlay, FaStar, FaGraduationCap, FaHeart, FaRocket } from "react-icons/fa";
import logo1 from "../assets/bubuschool.png";

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative pt-24 pb-16 min-h-screen overflow-hidden">
      {/* Light Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        {/* Floating Elements - Light Colors */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-blue-200/40 rounded-full blur-xl animate-bounce" style={{animationDuration: '3s'}}></div>
        <div className="absolute top-40 right-20 w-24 h-24 bg-purple-200/50 rounded-full blur-lg animate-bounce" style={{animationDelay: '1s', animationDuration: '4s'}}></div>
        <div className="absolute bottom-32 left-1/4 w-40 h-40 bg-indigo-200/30 rounded-full blur-2xl animate-bounce" style={{animationDelay: '2s', animationDuration: '5s'}}></div>
        <div className="absolute bottom-20 right-1/3 w-28 h-28 bg-cyan-200/40 rounded-full blur-xl animate-bounce" style={{animationDelay: '0.5s', animationDuration: '3.5s'}}></div>

        {/* Light Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/20 via-blue-50/30 to-white/20"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 lg:px-12 h-full flex items-center">
        <div className="w-full grid lg:grid-cols-2 gap-16 items-center">

          {/* Left Content */}
          <motion.div
            className="text-gray-800 space-y-8"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: isVisible ? 1 : 0, x: isVisible ? 0 : -50 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            {/* Badge */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm border border-blue-200 px-4 py-2 rounded-full text-sm font-medium text-blue-700 shadow-lg"
            >
              <FaStar className="text-yellow-500" />
              <span>Premium Education Center</span>
            </motion.div>

            {/* Main Title */}
            <div className="space-y-4">
              <motion.h1
                className="text-6xl lg:text-8xl xl:text-9xl font-bold font-platypi leading-tight"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                <motion.span
                  className="block text-gray-800 drop-shadow-lg"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  SMART
                </motion.span>
                <motion.span
                  className="block bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent drop-shadow-lg"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  EDUCARE
                </motion.span>
                <motion.span
                  className="block text-gray-800 drop-shadow-lg"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  CENTRE
                </motion.span>
              </motion.h1>
            </div>

            {/* Tagline */}
            <motion.div
              className="space-y-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
              transition={{ duration: 0.8, delay: 0.5 }}
            >
              <div className="relative">
                <p className="text-2xl lg:text-4xl font-medium font-platypi text-gray-700 drop-shadow-sm italic leading-relaxed">
                  "We Create A Smart Generation"
                </p>
                <div className="absolute -top-2 -left-2 text-6xl text-blue-300/40 font-bold">"</div>
                <div className="absolute -bottom-4 -right-2 text-6xl text-purple-300/40 font-bold">"</div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-32 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full shadow-lg"></div>
                <div className="w-4 h-4 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full shadow-lg animate-pulse"></div>
              </div>
            </motion.div>

            {/* CTA Buttons */}
            {/* <motion.div
              className="flex flex-col sm:flex-row gap-4 pt-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
              transition={{ duration: 0.8, delay: 0.7 }}
            >
              <motion.a
                href="https://wa.me/919834387679?text=Hi! I'm interested in enrolling my child at Smart Educare Center. Please provide information about available programs, admission process, fees, and schedule. Thank you!"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 text-lg font-semibold rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center space-x-2"
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaRocket className="group-hover:animate-bounce" />
                <span>Enroll Now</span>
              </motion.a>
              <motion.button
                className="group bg-white/80 backdrop-blur-sm px-8 py-4 text-lg font-semibold rounded-2xl border-2 border-blue-200 text-blue-700 hover:bg-white hover:shadow-lg transition-all duration-300 flex items-center justify-center space-x-2"
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaPlay className="group-hover:animate-pulse" />
                <span>Learn More</span>
              </motion.button>
            </motion.div> */}

            {/* Enhanced Stats */}
            {/* <motion.div
              className="grid grid-cols-3 gap-6 pt-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
              transition={{ duration: 0.8, delay: 0.9 }}
            >
              <motion.div
                className="text-center group cursor-pointer"
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
              >
                <div className="text-4xl font-bold text-blue-600 group-hover:text-blue-700 transition-colors">500+</div>
                <div className="text-sm text-gray-600 flex items-center justify-center space-x-1">
                  <FaGraduationCap />
                  <span>Happy Students</span>
                </div>
              </motion.div>
              <motion.div
                className="text-center group cursor-pointer"
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
              >
                <div className="text-4xl font-bold text-purple-600 group-hover:text-purple-700 transition-colors">10+</div>
                <div className="text-sm text-gray-600 flex items-center justify-center space-x-1">
                  <FaStar />
                  <span>Years Experience</span>
                </div>
              </motion.div>
              <motion.div
                className="text-center group cursor-pointer"
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
              >
                <div className="text-4xl font-bold text-indigo-600 group-hover:text-indigo-700 transition-colors">100%</div>
                <div className="text-sm text-gray-600 flex items-center justify-center space-x-1">
                  <FaHeart />
                  <span>Success Rate</span>
                </div>
              </motion.div>
            </motion.div> */}
          </motion.div>

          {/* Right Content - Logo */}
          <motion.div
            className="flex justify-center lg:justify-end"
            initial={{ opacity: 0, x: 50, scale: 0.8 }}
            animate={{
              opacity: isVisible ? 1 : 0,
              x: isVisible ? 0 : 50,
              scale: isVisible ? 1 : 0.8
            }}
            transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
          >
            <div className="relative">
              {/* Multiple Glow Effects */}
              <div className="absolute inset-0 bg-blue-300/30 rounded-full blur-3xl animate-pulse"></div>
              <div className="absolute inset-0 bg-purple-300/30 rounded-full blur-2xl animate-pulse" style={{animationDelay: '1s'}}></div>

              {/* Logo */}
              <motion.img
                src={logo1}
                alt="Smart Educare Centre Logo"
                className="relative z-10 w-80 lg:w-96 xl:w-[28rem] h-auto drop-shadow-2xl"
                whileHover={{
                  scale: 1.05,
                  rotate: [0, -2, 2, 0],
                  transition: { duration: 0.5 }
                }}
                animate={{
                  y: [0, -10, 0],
                  transition: {
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }
                }}
              />

              {/* Decorative Elements */}
              <motion.div
                className="absolute -top-4 -right-4 w-8 h-8 bg-cyan-400 rounded-full"
                animate={{
                  scale: [1, 1.2, 1],
                  opacity: [0.7, 1, 0.7]
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              ></motion.div>
              <motion.div
                className="absolute -bottom-4 -left-4 w-6 h-6 bg-pink-400 rounded-full"
                animate={{
                  scale: [1, 1.3, 1],
                  opacity: [0.6, 1, 0.6]
                }}
                transition={{
                  duration: 2.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                  delay: 0.5
                }}
              ></motion.div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: isVisible ? 1 : 0 }}
        transition={{ duration: 0.8, delay: 1.2 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/70"
      >
        <div className="flex flex-col items-center space-y-2">
          <span className="text-sm font-medium">Scroll to explore</span>
          <motion.div
            className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center"
            animate={{
              y: [0, 5, 0]
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <div className="w-1 h-3 bg-white/50 rounded-full mt-2"></div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
